export default __webpack_public_path__ + "static/media/pe.433e0c9c.svg";